import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Box, Flex } from '@chakra-ui/react'
import { withRouter } from 'react-router-dom'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import { FooterActionsParent } from 'src/components/Layout/Footer/FooterActions'
import Loader from 'src/components/Loader/Loader'
import { isEmpty } from 'src/utils/helpers'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import styles from './GroupAdd.module.less'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'
import { Input } from 'src/components/Form'
import Button from 'src/components/Button/Button'
import withToast from 'src/components/Toast'

class GroupAdd extends React.Component {
  state = {
    name: '',
  }

  componentDidUpdate(prevProps) {
    const { intl, history, saveGroupResponse, toast } = this.props

    // If there is save response and it changed (it's empty object while submitting)
    if (!isEmpty(saveGroupResponse) && saveGroupResponse !== prevProps.saveGroupResponse) {
      if (saveGroupResponse.success) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appSuccessTitle),
          description: intl.formatMessage(intlMessages.inventoryGroupSaveSuccess),
          status: 'success',
        })

        // Redirect back to list of groups
        history.push('/inventory')
      } else {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            saveGroupResponse.message || intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  handleSubmit = values => {
    const { inventoryGroupSave } = this.props

    // Submit through redux
    inventoryGroupSave({
      name: values.name,
    })
  }

  render() {
    const { intl, isSaveGroupInProgress, features } = this.props

    const foundedFeature = features.find(f => f.id == 'inventory')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.inventoryHeader)

    return (
      <Layout>
        <Content>
          <PageTitle
            title={
              intl.formatMessage(intlMessagesApp.appGlobalAdd) +
              ' ' +
              intl.formatMessage(intlMessages.inventoryRoom)
            }
            subtitle={title}
          />
          <Container padder className={styles.container + ' global-centered-desktop-content'}>
            {isSaveGroupInProgress ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <FooterActionsParent>
                <Form
                  onSubmit={this.handleSubmit}
                  render={({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      <Flex direction={'column'} align={'center'}>
                        <Box
                          mt={'20px'}
                          p={'30px'}
                          className={cx({
                            [styles.card]: true,
                            'kiosk--chakra-colors-card-background': true,
                          })}
                          mb={'30px'}
                          align={'center'}
                        >
                          <Box opacity={0.5}>
                            <FontAwesomeIconComponent icon={['fal', 'cube']} size='lg' />
                          </Box>
                        </Box>
                        <Field
                          name='name'
                          render={({ input }) => (
                            <Input
                              mt={6}
                              classNameHolder={styles.inputHolder}
                              name='name'
                              placeholder={intl.formatMessage(
                                intlMessages.inventoryPlaceholderRoom,
                              )}
                              type='text'
                              {...input}
                            />
                          )}
                        />
                        <Box mt={'30px'} maxW={{ lg: '440px', base: '100%' }} w={'100%'}>
                          <Button isFullWidth size='lg' type='submit'>
                            <Box mr={'10px'}>
                              <FontAwesomeIconComponent
                                icon={['fal', 'plus']}
                                size='xs'
                                type='white'
                              />
                            </Box>
                            Add new room
                          </Button>
                        </Box>
                      </Flex>
                    </form>
                  )}
                />
                {/* <Form onSubmit={this.handleSubmit}>
                  <div className={styles.formContent}>
                    <div className={styles.formFields}>
                      
                      <Input
                        classNameHolder={styles.inputHolder}
                        name="name"
                        placeholder={intl.formatMessage(intlMessages.inventoryPlaceholderRoom)}
                        options={{
                          initialValue: name,
                          rules: [{
                            required: true,
                            message: intl.formatMessage(intlMessages.inventoryValidationRoom)
                          }, {
                            max: 75,
                            message: intl.formatMessage(intlMessages.inventoryValidationRoomLength)
                          }]
                        }}
                        type="text"
                        onChange={(e) => this.handleFieldChange(e, 'name')}
                        { ...this.props }
                      />
                    </div>

                    <div className={styles.addRoomIconHolder}>
                      <SvgIcon type="AddRoom" className="" />
                    </div>

                    <FooterActions className={styles.footer}>
                      <Button type="primary" htmlType="submit">
                        {intl.formatMessage(intlMessagesApp.appGlobalAdd)}
                      </Button>
                    </FooterActions>
                  </div>
                </Form> */}
              </FooterActionsParent>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

GroupAdd.propTypes = {
  isSaveGroupInProgress: PropTypes.bool.isRequired,
  saveGroupResponse: PropTypes.object.isRequired,
  inventoryGroupSave: PropTypes.func.isRequired,
  intl: PropTypes.object,
  router: PropTypes.object,
}

export default withRouter(injectIntl(withToast(GroupAdd)))
